import React, { useMemo, useState } from "react";
import Navbar from "../components/Navbar.jsx";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import FilterBar from "../components/FilterBar";
import VendorGrid from "../components/VendorGrid";
import AboutSection from "../components/AboutSection";
import FaqSection from "../components/FaqSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import useVendors from "../hooks/useVendors";
import usePageMeta from "../hooks/usePageMeta";
import { useLang } from "../i18n/LanguageContext";

const DEFAULT_FILTERS = { category: "all", city: "all", type: "all" };

export default function Home() {
  const { t } = useLang();
  usePageMeta(t("meta.home"), t("meta.homeDesc"));
  const vendors = useVendors();
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const filtered = useMemo(() => {
    return vendors.filter((v) => {
      if (filters.category !== "all" && v.category !== filters.category)
        return false;
      if (filters.city !== "all" && v.city !== filters.city) return false;
      if (filters.type !== "all" && v.accountType !== filters.type)
        return false;
      return true;
    });
  }, [vendors, filters]);

  const stats = useMemo(
    () => ({
      businesses: vendors.length,
      cities: new Set(vendors.map((v) => v.city)).size,
      categories: new Set(vendors.map((v) => v.category)).size,
    }),
    [vendors],
  );

  return (
    <>
      <Navbar />
      <Hero />
      <Stats
        businesses={stats.businesses}
        cities={stats.cities}
        categories={stats.categories}
      />
      <FilterBar filters={filters} setFilters={setFilters} />
      <VendorGrid vendors={filtered} />
      <AboutSection />
      <FaqSection />
      <ContactSection />
      <Footer />
    </>
  );
}
